export enum ROUTE_NAMES {
  HOME = 'Home',
  // UI
  DASHBOARD = 'Dashboard',
  DOCS = 'Docs',
  PROFILE = 'Profile',
  LOGOUT = 'Logout',
  ERROR = 'Error',
  ERROR_PAGE = 'Error Page',
  NOT_FOUND = 'Not Found',
  // Contacts
  CONTACTS = 'Contacts',
  CONTACT_CREATE = 'Create Contact',
  CONTACT_EDIT = 'Edit Contact',
  NOTIFICATION_SETTINGS = 'Notification Settings',
  // LOGS
  ACTIVITY_LOGS = 'Activity Logs',
  ACTIVITY_LOGS_LOCATION = 'Activity Logs Location',
  // ORG
  ORGANIZATIONS = 'Organizations',
  CREATE_ORGANIZATION = 'Create Organization',
  ORGANIZATION = 'Organization',
  EDIT_ORGANIZATION = 'Edit Organization',
  // LOCATIONS
  LOCATIONS = 'Locations',
  CREATE_LOCATION = 'Create Location',
  EDIT_LOCATION = 'Edit Location',
  // Location
  LOCATION = 'Location',
  LOCATION_GENERAL = 'Location General',
  LOCATION_LINES = 'Location Lines',
  LOCATION_DIAGNOSTICS = 'Location Diagnostics',
  LOCATION_EMERGENCY = 'Location Emergency',
  LOCATION_MEDIA = 'Location Media',
  LOCATION_PERFORMANCE = 'Location Performance',
  // DIVISIONS
  DIVISIONS = 'Divisions',
  CREATE_DIVISION = 'Create Division',
  EDIT_DIVISION = 'Edit Division',
  // LINES
  LINES = 'Lines',
  CDRS = 'CDRs',
  LINES_EDIT_USER = 'Edit Lines User',
  LINES_EMERYGENCY_ADDRESS = 'Lines Emergency Address',
  // USERS
  USERS = 'Users',
  USER_CREATE = 'Invite User',
  USER_EDIT = 'Edit User',
  // HARDWARE
  BUNDLES = 'Bundles',
}

export enum TAB_ROUTES {
  GENERAL = 'general',
  SERVICES = 'services',
  DIAGNOSTICS = 'diagnostics',
  EMERGENCY = 'emergency',
  PERFORMANCE = 'performance',
}

export enum ENTITY_ROUTES {
  GATEWAY = 'gateways',
  ROUTER = 'routers',
  POWERSOURCE = 'powersources',
  HYBRID = 'hybrids',
  SIP_ENDPOINTS = 'sip-endpoints',
}
